<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" class="logo" src="../src/assets/img/logo_small.svg" width="100" height="auto" />
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i :class="menuIconClass"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true }">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<div class="breadcrumb-container">
			<breadcrumb :home="breadcrumb.menu.home" :model="breadcrumb.menu.items" />
		</div>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-search"></i>
					<span>Events</span>
				</button>
			</li> -->
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-envelope"></i>
					<span>Message</span>
				</button>
			</li> -->
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-user"></i>
					<span>Profile</span>
				</button>
			</li> -->
			<!-- <div>
				<Button class="p-link layout-topbar-button" @click="$refs.menu1.toggle($event)">
					<i class="pi pi-cog"></i>
					<Menu  ref="menu1" :popup="true" :model="items"></Menu>
					<span>Dropdown</span>
				</Button>
			</div> -->
			<li v-if="canSeeRecallCalendar" class="flex justify-content-center align-items-center mx-3">
				<button @click="toggleRecallDialog" class="p-link flex align-items-center recall-topbar-btn" title="Richiamami">
					<i class="pi pi-phone recall-topbar-icon"
						v-badge.danger="todayRecallCount"></i>
				</button>
			</li>
			<li class="flex justify-content-center align-items-center mx-3">
				<button @click="toggleInfoPanel" class="p-link flex align-items-center" title="Interni">
					<i class="pi pi-info-circle"
						style="font-size: 1.2rem; background-color: var(--blue-900); color: white; padding: 10px; border-radius: 30px;"></i>
				</button>
			</li>
			<li class="flex justify-content-center align-items-center mx-3">
				<router-link to="/richiesta-ferie" class="p-link" title="Ferie e permessi">
					<i class="pi pi-calendar"
						style="font-size: 1.2rem; background-color: var(--blue-900); color: white; padding: 10px; border-radius: 30px;"></i>
				</router-link>
			</li>
			<li class="flex justify-content-center align-items-center mx-5">
				<router-link :to="`/tickets`" class="p-link">
					<i class="pi pi-ticket"
						style="font-size: 1.2rem; background-color: var(--blue-900); color: white; padding: 10px; border-radius: 30px;"
						v-badge.danger="newTickets"></i>
				</router-link>
			</li>
			<li class="flex justify-content-center align-items-center mx-5">
				<button @click="showConfirmDialog" class="p-link flex align-items-center">
					<i class="pi pi-sign-out"
						style="font-size: 1.2rem; background-color: var(--blue-900); color: white; padding: 10px; border-radius: 30px;"></i>
					<span style="color: white;">Logout</span>
				</button>
			</li>
			<!-- <li v-if="currentUser"  class="email-box">
				<small>{{currentUser.user[0].email}}</small>		
			</li> -->
		</ul>
	</div>

	<div v-if="isInfoPanelOpen" class="info-panel-backdrop" @click="closeInfoPanel"></div>
	<aside :class="['info-panel', { 'info-panel-open': isInfoPanelOpen }]">
		<div class="info-panel-header">
			<h4 class="m-0">Interni</h4>
			<button class="p-link info-panel-close" @click="closeInfoPanel">
				<i class="pi pi-times"></i>
			</button>
		</div>
		<div class="info-panel-content">
			<div class="operator-row" v-for="op in operatoriSospesi" :key="op.nome">
				<span class="operator-name">{{ op.nome }}</span>
				<span class="operator-ext">Int. {{ op.interno }}</span>
			</div>
		</div>
	</aside>
	<RecallClientCalendarDialog v-if="canSeeRecallCalendar" v-model:visible="isRecallDialogOpen" />
	<ConfirmDialog></ConfirmDialog>
</template>

<script>
import { ref, getCurrentInstance, onMounted, watch } from 'vue'
import TicketService from '@/services/ask-ticket/ticket-service'
import services from '@/config/services'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router';
import { computed } from "vue";
import { useConfirm } from "primevue/useconfirm";
import RecallClientCalendarDialog from '@/components/RecallClientCalendarDialog.vue'
import PanelAdminService from '@/services/ask-admin/panel-admin'
// import Cookies from "js-cookie";
// const inboxMessageSound = require("@/assets/sound/new_message_inbox.mp3");

export default ({
	components: { RecallClientCalendarDialog },
	emits: ["menu-toggle", "topbar-menu-toggle"],
	setup() {
		const self = getCurrentInstance();
		const eventBus = self.appContext.config.globalProperties.$eventBus
		const http = self.appContext.config.globalProperties.$http
		const appState = self.appContext.config.globalProperties.$appState
		const ticketService = new TicketService(http, eventBus)
		const panelAdminService = new PanelAdminService(http, eventBus)
		const newTickets = ref(0)
		const todayRecallCount = ref(0)
		const store = useStore()
		const router = useRouter()
		// const inboxMessageAudio = new Audio(inboxMessageSound)
		const currentUser = ref(JSON.parse(atob(store.state.auth.user)))
		const confirm = useConfirm();
		const isMenuOpen = ref(false);
		const isInfoPanelOpen = ref(false);
		const isRecallDialogOpen = ref(false);
		const RECALL_CALENDAR_PROFILE_EXT_IDS = [10, 16]

		const canSeeRecallCalendar = computed(() => {
			const user = currentUser.value?.user?.[0]
			const profile = user?.profile
			if (!profile && !user) return false
			const extId = Number(profile?.profile_ext_id ?? user?.profile_ext_id ?? profile?.id)
			if (RECALL_CALENDAR_PROFILE_EXT_IDS.includes(extId)) return true
			const name = String(profile?.name || '').toLowerCase()
			return name === 'segreteria' || name === 'assistenza_clienti' || Number(profile?.assistenza_clienti) === 1
		})
		const operatoriSospesi = ref([
		]);
		const breadcrumb = ref({
			menu: {
				home: { icon: 'pi pi-home', to: '/home', style: { 'color': 'white !important' } },
				items: [{ label: 'Home' }],
				style: {
					'background-color': 'white !important'
				}
			}
		});
		const items = ref([
			// {
			// 	label: 'items1',
			// 	to: '/'			
			// },
			// {
			// 	label: 'items2',
			// 	to: '/'
			// },
		])

		onMounted(async () => {
			loadInterniVoxloud()
			getNewTicketsNumbers()
			if (canSeeRecallCalendar.value) {
				loadTodayRecallCount()
				window.setInterval(() => {
					loadTodayRecallCount()
				}, 60000)
			}
			window.setInterval(() => {
				getNewTicketsNumbers()
			}, 6000000)
		})
		watch(() => router.currentRoute.value, (to) => {
			breadcrumb.value.menu.items = [{ label: to.name, style: { color: 'white' } }];
		});

		const getNewTicketsNumbers = () => {
			// store.dispatch("tickets/saveNumbers", newTickets.value)
			ticketService.getNewTicketsNumbers().then((res) => {
				newTickets.value = res.items
				// console.log(store);
			})
		}

		const loadTodayRecallCount = async () => {
			todayRecallCount.value = await panelAdminService.getRecallClientTodayCount()
		}

		const loadInterniVoxloud = async () => {
			const url = `${services.ask_pratiche.url}/getInternalVoxloud`
			try {
				const res = await http.get(url)
				const rows = Array.isArray(res?.data) ? res.data : []
				operatoriSospesi.value = rows.map((row) => ({
					nome: row?.full_name || '-',
					interno: row?.extension_number || '-',
				}))
			} catch (error) {
				operatoriSospesi.value = []
				eventBus.emit('data-load-error', { message: error, url })
			}
		}
		eventBus.on('update-numbers-ticket', () => {
			getNewTicketsNumbers()
			if (canSeeRecallCalendar.value) {
				loadTodayRecallCount()
			}
		})

		const menuIconClass = computed(() => {
			return isMenuOpen.value ? 'pi pi-bars' : 'pi pi-bars';
		})

		const onMenuToggle = (event) => {
			isMenuOpen.value = !isMenuOpen.value;
			eventBus.emit('menu-toggle', event);
		}

		const toggleInfoPanel = () => {
			isInfoPanelOpen.value = !isInfoPanelOpen.value;
		}

		const closeInfoPanel = () => {
			isInfoPanelOpen.value = false;
		}

		const toggleRecallDialog = () => {
			isRecallDialogOpen.value = true;
		}

		const showConfirmDialog = () => {
			confirm.require({
				message: 'Vuoi effettuare il logout?',
				header: 'Conferma',
				icon: 'pi pi-info-circle',
				accept: () => {
					handleLogout()
				},
				// reject: () => {
				// 	console.log('rifiuto')
				// }
			});
		}

		const handleLogout = () => {
			store.dispatch("auth/logout").then(
				() => {
					router.push("/login");
				},
				(error) => {
					console.log(error)
				}
			);
		}
		// const onMenuToggle = (event) => {
		// 	eventBus.emit('menu-toggle', event);
		// }

		const onTopbarMenuToggle = (event) => {
			eventBus.emit('topbar-menu-toggle', event);
		}

		const darkTheme = computed(() => {
			return appState.theme.startsWith('saga');
		})


		return {
			breadcrumb,
			items,
			onMenuToggle,
			menuIconClass,
			onTopbarMenuToggle,
			darkTheme,
			handleLogout,
			showConfirmDialog,
			currentUser,
			newTickets,
			todayRecallCount,
			canSeeRecallCalendar,
			isMenuOpen,
			isInfoPanelOpen,
			operatoriSospesi,
			toggleInfoPanel,
			closeInfoPanel,
			isRecallDialogOpen,
			toggleRecallDialog
		}
	}


})
</script>
<style scoped>
.breadcrumb.menu.items {
	color: white !important;
}

.icon-logout {
	transform: rotate(-90deg);
}

.email-box {
	display: flex;
	justify-content: center;
	align-items: center;
}

.breadcrumb-container {
	margin: 0 auto;
	display: flex;
	justify-content: flex-start;
	margin-top: 20px;
}

.logo {
	width: 100px;
	height: auto;
	margin-left: 50px;
}

:deep(.p-breadcrumb .p-menuitem-link .p-menuitem-icon),
:deep(.p-breadcrumb .p-menuitem-link .p-menuitem-text) {
	color: white;
}

:deep(.p-breadcrumb .p-breadcrumb-chevron) {
	color: white;
}

@media (max-width: 991px) {
	.layout-menu-button {
		position: relative !important;
		left: 0 !important;
		top: 0 !important;
	}

	.layout-topbar .layout-topbar-menu-button {
		display: none !important;
	}
}

.breadcrumb-container {
	display: none;
}

.logo {
	margin-left: 0;
}

.layout-topbar {
	padding: 0 1rem !important;
}

.recall-topbar-btn {
	position: relative;
}

.recall-topbar-icon {
	font-size: 1.2rem;
	background-color: var(--blue-900);
	color: white;
	padding: 10px;
	border-radius: 30px;
}

.info-panel-backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.35);
	z-index: 999;
}

.info-panel {
	position: fixed;
	top: 0;
	right: -340px;
	width: 340px;
	height: 100vh;
	background: linear-gradient(180deg, #0d3c61 0%, #3388b3 100%);
	box-shadow: -10px 0 28px rgba(0, 0, 0, 0.28);
	z-index: 1000;
	transition: right 0.25s ease;
	display: flex;
	flex-direction: column;
	color: #ffffff;
}

.info-panel-open {
	right: 0;
}

.info-panel-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	background: rgba(255, 255, 255, 0.08);
	backdrop-filter: blur(2px);
}

.info-panel-header h4 {
	color: #ffffff;
	font-weight: 700;
	letter-spacing: 0.3px;
}

.info-panel-close {
	color: #ffffff;
}

.info-panel-content {
	padding: 0.75rem 1rem 1rem 1rem;
	overflow-y: auto;
	max-height: calc(100vh - 72px);
}

.operator-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.85rem 0.5rem;
	border-bottom: 1px solid rgba(255, 255, 255, 0.18);
	border-radius: 8px;
	transition: background-color 0.2s ease;
}

.operator-row:hover {
	background-color: rgba(255, 255, 255, 0.1);
}

.operator-name {
	font-weight: 600;
	color: #ffffff;
}

.operator-ext {
	color: rgba(255, 255, 255, 0.9);
	font-size: 0.9rem;
}
</style>
